module.exports = __webpack_public_path__ + "static/media/themify.9c8e96ec.svg";